<script setup>

import { defineProps, defineEmits, computed, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "controlesDesativados",
    "aprovandoDado",
    "dadoOriginal"
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraAprovandoDado",
]);

//==================================================================//
//============================ Dado ================================//
//==================================================================//

const dado = ref({});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//==================== Altera Aprovando Dado =======================//
//==================================================================//

const alteraAprovandoDado = (update = {}) =>{

    update.modal = false;
    emits('update:alteraAprovandoDado',update);

};

//==================================================================//
//========================== Altera Dado ===========================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update);

};


//==================================================================//
//=============== Altera Dado Filtrado Parcelas ====================//
//==================================================================//

const alteraContasAPagar = (update)=>{

    let contasAPagar = dado?.value?.contasAPagar?.map((contaAPagar)=>{

        return UtilObject.merge(contaAPagar, update);

    });

    let selecionado = contasAPagar?.every(({selecionado})=> selecionado == true);

    alteraDado({
        selecionado: selecionado,
        contasAPagar: contasAPagar
    });

};

//==================================================================//
//===================== Altera Conta a Pagar =======================//
//==================================================================//

const alteraContaAPagar = (update)=>{

    let contasAPagar = dado?.value?.contasAPagar?.map((contaAPagar)=>{

        if(contaAPagar.id != update.id){
            return contaAPagar;
        }

        return UtilObject.merge(contaAPagar,update);

    });

    let selecionado = contasAPagar?.every(({selecionado})=> selecionado == true);

    alteraDado({
        selecionado: selecionado,
        contasAPagar: contasAPagar
    });

};

//==================================================================//
//============= Altera Justificativa de Reprovacao =================//
//==================================================================//

const alteraJustificativaDeReprovacao = (update)=>{

    alteraDado({
        justificativaDeReprovacao: update
    });

};

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {})=>{

    let contasAPagar = dado?.parcelas?.reduce((acc,parcela)=>{

        let contaAPagar = parcela?.contaAPagar;

        // Desconsidera todas as Contas a Pagar que não estão Aguardando Aprovação.
        if(contaAPagar.status != "Aguardando Aprovação"){
            return acc;
        }

        let pagamentos = contaAPagar?.pagamentos?.map((pagamento)=>{

            return{
                id: pagamento?.id || "",
                sequencia: pagamento?.sequencia || "",
                status: pagamento?.status || "",
                notaFiscalRecebidaID: pagamento?.notaFiscalRecebida?.id || "", 
                notaFiscalRecebidaNumero: pagamento?.notaFiscalRecebida?.numero || "",
                notaFiscalRecebidaChaveAcesso: pagamento?.notaFiscalRecebida?.chaveAcesso || "",
                notaFiscalRecebidaPlugNotasID: pagamento?.notaFiscalRecebida?.plugNotasID || "",
                dataCriacao: pagamento?.dataVencimentoFormatada || "",
                dataVencimento: pagamento?.dataVencimentoFormatada || "",
                valorDesconto: pagamento?.valorDesconto || 0,
                valorPagamento: pagamento?.valorPagamento || 0,
                valorReservado: pagamento?.valorReservado || 0,
                valorParaPagar: pagamento?.valorParaPagar || 0,
                valorPago: pagamento?.valorPago || 0,
                valorParaVincular: pagamento?.valorParaVincular || 0,
                valorVinculado: pagamento?.valorVinculado || 0,
            }

        });

        acc.push({
            id: contaAPagar?.id || "",
            aberto: false,
            selecionado: false,
            codigo: contaAPagar?.codigo || "",
            parcelaCodigo: parcela?.codigo || "",
            status: contaAPagar?.status || "",
            forma: contaAPagar?.pagamentoForma || "",
            tipo: contaAPagar?.pagamentoTipo || "",
            evento: contaAPagar?.pagamentoEvento || "",
            descricao: contaAPagar?.descricao || "",
            dataVencimento: contaAPagar?.dataVencimentoFormatada || "",
            valorOriginal: contaAPagar?.valorOriginal || 0,
            valorParaReservar: contaAPagar?.valorParaReservar || 0,    
            valorDesconto: contaAPagar?.valorDesconto || 0,
            valorPagamento: contaAPagar?.valorPagamento || 0,
            valorReservado: contaAPagar?.valorReservado || 0,
            valorParaPagar: contaAPagar?.valorParaPagar || 0,
            valorPago: contaAPagar?.valorPago || 0,
            valorParaVincular: contaAPagar?.valorParaVincular || 0,
            valorVinculado: contaAPagar?.valorVinculado || 0,
            liberadorNome: contaAPagar?.liberador?.nome || "",
            aprovadorNome: contaAPagar?.aprovador?.nome || "",
            reprovadorNome: contaAPagar?.reprovador?.nome || "",
            reprovadorJustificativa: contaAPagar?.reprovadorJustificativa || "",
            pagamentos: pagamentos || [],
            pagamentosQuantidade: contaAPagar?.pagamentosQuantidade || 0,
        });

        return acc;

    },[]);

    dado = {
        id: dado?.id,
        selecionado: false,
        tipo: dado?.tipo,
        codigo: dado?.codigo,
        justificativaDeReprovacao: "",
        contasAPagar: contasAPagar || []
    }

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//====================================================================//
//=== Prepara Modal se Dados Originais Carregados ou Recarregados ====//
//===================== Watch => aprovandoDado =======================//
//====================================================================//

watch(()=> props?.aprovandoDado, () => {

    if(props?.aprovandoDado == true){
        preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.aprovandoDado"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :controlesDesativados="controlesDesativados"
                    :dado="dado"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraAprovandoDado="alteraAprovandoDado"
                ></BarraNavegacao>

                <DadoConteudo
                    :controlesDesativados="props.controlesDesativados"
                    :dado="dado"
                    @update:alteraContasAPagar="alteraContasAPagar"
                    @update:alteraContaAPagar="alteraContaAPagar"
                    @update:alteraJustificativaDeReprovacao="alteraJustificativaDeReprovacao"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

